// https://api.jquery.com/jquery.extend/#jQuery-extend-deep-target-object1-objectN
( function () {
    'use strict';
    jQuery.extend( true, e4.settings, {
        require: {
            datepicker: {
                url: '//cdnjs.cloudflare.com/ajax/libs/bootstrap-datepicker/1.9.0/js/bootstrap-datepicker.min.js',
                fallback: '/files/templates/designs/alcadon/_assets/js/vendor/bootstrap-datepicker.js',
                callback: function () {
                    if ( e4.settings.lang === 'en' ) {
                        e4.settings.require.datepickerLanguage.url = e4.settings.require.datepickerLanguage.url.replace( '{lang}', 'en-GB' );
                        e4.settings.require.datepickerLanguage.fallback = e4.settings.require.datepickerLanguage.fallback.replace( '{lang}', 'en-GB' );
                    }
                    else {
                        e4.settings.require.datepickerLanguage.url = e4.settings.require.datepickerLanguage.url.replace( '{lang}', e4.settings.lang );
                        e4.settings.require.datepickerLanguage.fallback = e4.settings.require.datepickerLanguage.fallback.replace( '{lang}', e4.settings.lang );
                    }
                }
            },
            datepickerLanguage: {
                url: '//cdnjs.cloudflare.com/ajax/libs/bootstrap-datepicker/1.9.0/locales/bootstrap-datepicker.{lang}.min.js',
                fallback: '/files/templates/designs/alcadon/_assets/js/vendor/bootstrap-datepicker.{lang}.min.js',
                callback: null
            }
        },
        ecom: {
            cart: {
                url: ( function () {
                    return jQuery( 'body' ).data( 'isUserAuthenticated' ) ? '/system/data/cart' : '/system/data/quotes'
                }() ),
                msgHideDelay: 1500
            }
        },
        search: {
            result: {
                products: {
                    show: location.hostname.endsWith('.be') === false, 
                    max: 5
                }
            },
        },
        dealersearch: {
            url: '/system/data/dealersearch',
            fitMapToBoundsOnInit: true,
            results: {
                min: 2,
                sensitivity: 0.5,
                zoom: {
                    min: 12,
                    max: 15
                }
            },
            map: {
                styles: [
                    {
                        'elementType': 'geometry',
                        'stylers': [
                            {
                                'color': '#f5f5f5'
                            }
                        ]
                    },
                    {
                        'elementType': 'labels.icon',
                        'stylers': [
                            {
                                'visibility': 'off'
                            }
                        ]
                    },
                    {
                        'elementType': 'labels.text.fill',
                        'stylers': [
                            {
                                'color': '#616161'
                            }
                        ]
                    },
                    {
                        'elementType': 'labels.text.stroke',
                        'stylers': [
                            {
                                'color': '#f5f5f5'
                            }
                        ]
                    },
                    {
                        'featureType': 'administrative',
                        'elementType': 'geometry',
                        'stylers': [
                            {
                                'visibility': 'off'
                            }
                        ]
                    },
                    {
                        'featureType': 'administrative.land_parcel',
                        'elementType': 'labels.text.fill',
                        'stylers': [
                            {
                                'color': '#bdbdbd'
                            }
                        ]
                    },
                    {
                        'featureType': 'poi',
                        'stylers': [
                            {
                                'visibility': 'off'
                            }
                        ]
                    },
                    {
                        'featureType': 'poi',
                        'elementType': 'geometry',
                        'stylers': [
                            {
                                'color': '#eeeeee'
                            }
                        ]
                    },
                    {
                        'featureType': 'poi',
                        'elementType': 'labels.text.fill',
                        'stylers': [
                            {
                                'color': '#757575'
                            }
                        ]
                    },
                    {
                        'featureType': 'poi.park',
                        'elementType': 'geometry',
                        'stylers': [
                            {
                                'color': '#e5e5e5'
                            }
                        ]
                    },
                    {
                        'featureType': 'poi.park',
                        'elementType': 'labels.text.fill',
                        'stylers': [
                            {
                                'color': '#9e9e9e'
                            }
                        ]
                    },
                    {
                        'featureType': 'road',
                        'elementType': 'geometry',
                        'stylers': [
                            {
                                'color': '#ffffff'
                            }
                        ]
                    },
                    {
                        'featureType': 'road',
                        'elementType': 'labels.icon',
                        'stylers': [
                            {
                                'visibility': 'off'
                            }
                        ]
                    },
                    {
                        'featureType': 'road.arterial',
                        'elementType': 'labels.text.fill',
                        'stylers': [
                            {
                                'color': '#757575'
                            }
                        ]
                    },
                    {
                        'featureType': 'road.highway',
                        'elementType': 'geometry',
                        'stylers': [
                            {
                                'color': '#dadada'
                            }
                        ]
                    },
                    {
                        'featureType': 'road.highway',
                        'elementType': 'labels.text.fill',
                        'stylers': [
                            {
                                'color': '#616161'
                            }
                        ]
                    },
                    {
                        'featureType': 'road.local',
                        'elementType': 'labels.text.fill',
                        'stylers': [
                            {
                                'color': '#9e9e9e'
                            }
                        ]
                    },
                    {
                        'featureType': 'transit',
                        'stylers': [
                            {
                                'visibility': 'off'
                            }
                        ]
                    },
                    {
                        'featureType': 'transit.line',
                        'elementType': 'geometry',
                        'stylers': [
                            {
                                'color': '#e5e5e5'
                            }
                        ]
                    },
                    {
                        'featureType': 'transit.station',
                        'elementType': 'geometry',
                        'stylers': [
                            {
                                'color': '#eeeeee'
                            }
                        ]
                    },
                    {
                        'featureType': 'water',
                        'elementType': 'geometry',
                        'stylers': [
                            {
                                'color': '#c9c9c9'
                            }
                        ]
                    },
                    {
                        'featureType': 'water',
                        'elementType': 'labels.text.fill',
                        'stylers': [
                            {
                                'color': '#9e9e9e'
                            }
                        ]
                    }
                ]
            }
        }
    } );
}() );

